import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { formatInspectionState } from '../../redux/affair/affairStatus';
import { getAndLoadIntervention } from '../../redux/intervention/extranetInterventionActions';
import TableWithoutPagination from '../Table/TableWithoutPagination';

class Inspections extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    Header: "Numéro",
                    minWidth: 100,
                    maxWidth: 200,
                    id: 'sequence',
                    accessor: i => i.sequence,
                },
                {
                    Header: "Mois",
                    minWidth: 100,
                    maxWidth: 200,
                    id: 'date_planned_theoretical',
                    accessor: i => moment(i.date_planned_theoretical).format("DD/MM/YYYY"),
                },
                {
                    Header: "Etat",
                    minWidth: 100,
                    maxWidth: 200,
                    id: 'state',
                    accessor: i => formatInspectionState(i.state),
                },
                {
                    Header: "Intervention",
                    minWidth: 100,
                    maxWidth: 200,
                    id: 'intervention',
                    accessor: i => i.work_order_ids && i.work_order_ids.length > 0 ? i.work_order_ids[0].name : "",
                },
                {
                    Header: "Commentaire",
                    accessor: "comments",
                },
            ]
        }
    }

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row && rowInfo.row._original.work_order_ids[0]) {
            return {
                onClick: this.loadIntervention.bind(this, rowInfo.row._original.work_order_ids[0]),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    loadIntervention(intervention) {
        this.props.getAndLoadIntervention(intervention, this.props.activeUser, () => {
            this.props.history.push("/interventions/intervention");
            this.props.globalStore.container.current.scrollTop = 0
        });
    }

    render() {
        return (
            <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <TableWithoutPagination
                    data={this.props.affair.inspection_ids}
                    columns={this.state.columns}
                    getTrProps={this.getTableTrProps.bind(this)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        affair: state.affair.currentAffair,
        activeUser: state.activeUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAndLoadIntervention: (intervention, user, onSuccess) => dispatch(getAndLoadIntervention(intervention, user, onSuccess)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Inspections);
